<template>
  <div ref="pdfContent" class="pdf-content">
    <CCard class="border-0">
      <CCardHeader v-if="!hideControls" class="no-print bg-transparent">
        <div class="float-right">
          <a href="#" class="btn btn-sm btn-info ml-1" @click="printContent">
            <CIcon name="cil-print" class="mr-1" /> Print
          </a>
        </div>
      </CCardHeader>
      <CCardBody>
        <div class="header">
          <CRow class="align-items-start mb-3">
            <CCol cols="3" md="2" class="text-left">
              <img
                :src="getImageUrl()"
                alt="Logo Syarikat"
                class="logo-image"
              />
            </CCol>
            <CCol cols="9" md="10" class="text-right company-info">
              <h1 class="company-name">{{ company.name }}</h1>
              <p class="company-tagline">{{ company.tagLine }}</p>
              <p class="company-regno">{{ "(" + company.regNo + ")" }}</p>
              <p class="company-address" v-html="formatAddress(company.address)"></p>
              <p class="company-phone">Tel: {{ company.phone }}</p>
            </CCol>
          </CRow>
          <hr class="thick-hr" />
        </div>
        <div class="invoice-details">
          <h3 class="text-center">INVOICE</h3>
          <CRow>
            <CCol md="6">
              <p><strong>MRS/MR:</strong> {{ getCustomerName() }}</p>
              <p>{{ getCustomerIcNumber() }}</p>
              <p v-html="formatAddress(getCustomerAddress())"></p>
            </CCol>
            <CCol md="6" class="text-right">
              <p><strong>No:</strong> {{ stock.stockNo }}</p>
              <p><strong>Salesman:</strong> {{ getSalesmanName() }}</p>
              <p><strong>Date:</strong> {{ getRegistrationDate() }}</p>
            </CCol>
          </CRow>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Particulars</th>
              <th class="text-right">Amounts (RM)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Selling Price</td>
              <td class="text-right">
                {{ formatMoney(getSellingPrice()) }}
              </td>
            </tr>

            <tr v-if="getInsuranceAmount() > 0">
              <td>Insurance</td>
              <td class="text-right">{{ formatMoney(getInsuranceAmount()) }}</td>
            </tr>

            <tr v-if="getTransferFeeAmount() > 0">
              <td>Vehicle Transfer Fee</td>
              <td class="text-right">{{ formatMoney(getTransferFeeAmount()) }}</td>
            </tr>

            <tr v-if="getRegistrationFeeAmount() > 0">
              <td>Vehicle Registration Fee</td>
              <td class="text-right">{{ formatMoney(getRegistrationFeeAmount()) }}</td>
            </tr>

            <tr v-if="getRoadtaxAmount() > 0">
              <td>Road Tax</td>
              <td class="text-right">{{ formatMoney(getRoadtaxAmount()) }}</td>
            </tr>

            <!-- Other admin cost items (EZCARE Warranty, etc.) are excluded from invoice -->
            <tr>
              <td><p></p></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Total Amount Due</strong></td>
              <td class="text-right">
                <strong>{{ formatMoney(getTotalAmountDue()) }}</strong>
              </td>
            </tr>
            <tr>
              <td><p></p></td>
              <td></td>
            </tr>

            <tr>
              <td>Less: Trade In</td>
              <td class="text-right">
                {{ formatMoney((stock.sale?.tradeInAmount || 0).toFixed(2)) }}
              </td>
            </tr>
            <tr>
              <td>Less: Deposit</td>
              <td class="text-right">
                {{ formatMoney((stock.sale?.depositAmount || 0).toFixed(2)) }}
              </td>
            </tr>
            <tr>
              <td><p></p></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Total Less</strong></td>
              <td class="text-right">
                <strong>{{ formatMoney(getTotalLess()) }}</strong>
              </td>
            </tr>
            <tr>
              <td><p></p></td>
              <td></td>
            </tr>

            <tr>
              <td>
                <strong>Net Amount Due From H.P Company</strong>
                {{ getLoanBankName() }}
              </td>
              <td class="text-right">
                <strong>{{ formatMoney(getNetAmountDue()) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="vehicle-details">
          <p><strong>Chassis No:</strong> {{ getVehicleChasisNo() }}</p>
          <p><strong>Engine No:</strong> {{ getVehicleEngineNo() }}</p>
          <p><strong>Regn. No:</strong> {{ getPlateNo() }}</p>
          <p><strong>Model:</strong> {{ getBrandModelNo() }}</p>
        </div>
        <div class="signature text-right">
          <p>For {{ company.name }}</p>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "WidgetsReportInvoice",
  props: {
    stock: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
      validator: (value) => {
        return ["name", "tagLine", "address", "phone", "logoUrl"].every(
          (prop) => prop in value
        );
      },
    },
    hideControls: {
      type: Boolean,
      default: false,
    },
    // customer: {
    //   type: Object,
    //   required: true,
    //   validator: (value) => {
    //     return ["name", "icNumber", "address"].every((prop) => prop in value);
    //   },
    // },
    // invoice: {
    //   type: Object,
    //   required: true,
    //   validator: (value) => {
    //     return [
    //       "number",
    //       "date",
    //       "items",
    //       "totalAmount",
    //       "tradeIn",
    //       "deposit",
    //       "netAmountDue",
    //     ].every((prop) => prop in value);
    //   },
    // },
    // vehicle: {
    //   type: Object,
    //   required: true,
    //   validator: (value) => {
    //     return ["chassisNo", "engineNo", "regnNo", "model"].every(
    //       (prop) => prop in value
    //     );
    //   },
    // },
  },
  mounted() {
    this.forceA4Size();
  },
  methods: {
    formatMoney(value) {
      // Convert to number and format with commas
      const num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    forceA4Size() {
      const pdfContent = this.$refs.pdfContent;
      if (pdfContent) {
        pdfContent.style.width = "210mm";
      }
    },
    getLoanBankName() {
      try {
        console.log("getLoanBankName", this.stock);
        return this.stock.sale?.loan?.bank?.name || "";
      } catch (error) {
        return "";
      }
    },
    getRegistrationDate() {
      try {
        const raw = this.stock && this.stock.registration && this.stock.registration.vehicleRegistrationDate;
        if (!raw) return "-";
        const d = new Date(raw);
        if (isNaN(d.getTime())) return "-";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return "-";
      }
    },
    getNetAmountDue() {
      var totalAmount = this.getTotalAmountDue() - this.getTotalLess();
      return totalAmount.toFixed(2);
    },
    getTotalLess() {
      var totalAmount = 0;
      try {
        totalAmount =
          this.stock.sale.depositAmount + this.stock.sale.tradeInAmount;
      } catch (error) {}
      return totalAmount.toFixed(2);
    },
    getTotalAmountDue() {
      var totalAmount = 0;
      try {
        totalAmount = this.stock.sale.saleAmount;

        // Add the 4 individual administrative costs
        totalAmount += (this.stock.adminitrativeCost?.insuranceAmount || 0);
        totalAmount += (this.stock.adminitrativeCost?.transferFeeAmount || 0);
        totalAmount += (this.stock.adminitrativeCost?.registrationFeeAmount || 0);
        totalAmount += (this.stock.adminitrativeCost?.roadtaxAmount || 0);

        // Dynamic administrative cost items (EZCARE Warranty, etc.) are excluded from invoice total
      } catch (error) {}
      return totalAmount.toFixed(2);
    },
    getSellingPrice() {
      try {
        return this.stock.sale.saleAmount.toFixed(2);
      } catch (error) {
        return null;
      }
    },
    getPlateNo() {
      try {
        return this.stock.registration.vehicleRegistrationNumber;
      } catch (error) {
        return "N/A";
      }
    },
    getBrandModelNo() {
      try {
        return (
          this.stock.vehicle.brand.name + " - " + this.stock.vehicle.model.name
        );
      } catch (error) {
        return "N/A";
      }
    },
    getVehicleEngineNo() {
      try {
        return this.stock.vehicle.engineNo;
      } catch (error) {
        return "N/A";
      }
    },
    getVehicleChasisNo() {
      try {
        return this.stock.vehicle.chasisNo;
      } catch (error) {
        return "N/A";
      }
    },
    getCustomerAddress() {
      try {
        return this.stock.sale.customer.address;
      } catch (error) {
        return "N/A";
      }
    },
    getCustomerName() {
      try {
        return this.stock.sale.customer.name;
      } catch (error) {
        return "N/A";
      }
    },
    getSalesmanName() {
      try {
        return this.stock.sale.salesMan?.fullName || "N/A";
      } catch (error) {
        return "N/A";
      }
    },
    getInsuranceAmount() {
      try {
        const amount = this.stock.adminitrativeCost?.insuranceAmount || 0;
        return amount.toFixed(2);
      } catch (error) {
        return (0).toFixed(2);
      }
    },
    getTransferFeeAmount() {
      try {
        const amount = this.stock.adminitrativeCost?.transferFeeAmount || 0;
        return amount.toFixed(2);
      } catch (error) {
        return (0).toFixed(2);
      }
    },
    getRegistrationFeeAmount() {
      try {
        const amount = this.stock.adminitrativeCost?.registrationFeeAmount || 0;
        return amount.toFixed(2);
      } catch (error) {
        return (0).toFixed(2);
      }
    },
    getRoadtaxAmount() {
      try {
        const amount = this.stock.adminitrativeCost?.roadtaxAmount || 0;
        return amount.toFixed(2);
      } catch (error) {
        return (0).toFixed(2);
      }
    },
    getCustomerIcNumber() {
      try {
        return this.stock.sale.customer.icNumber;
      } catch (error) {
        return "N/A";
      }
    },
    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    getImageUrl() {
      var url = this.removeTrailingSlash(apiUrl) + this.company.logoUrl;
      console.log(url);
      return url;
    },
    formatAddress(address) {
      return address.replace(/\n/g, "<br />");
    },
    saveAsPDF() {
      const element = this.$refs.pdfContent;
      const options = {
        margin: [0.5, 0.5, 0.5, 0.5], // Top, right, bottom, left
        filename: "Invoice.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(element).set(options).save();
    },
    printContent() {
      const printContents = this.$refs.pdfContent.innerHTML;
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.thick-hr {
  border: 1px solid #000;
  margin: 10px 0;
}

.pdf-content {
  width: 210mm;
  max-width: 100%;
  margin: 0 auto;
  padding: 15mm;
  box-sizing: border-box;
  background-color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.4;
  color: #333;
}

.logo-image {
  max-width: 120px;
  height: auto;
  display: block;
}

.header {
  page-break-after: avoid;
  page-break-inside: avoid;
  margin-bottom: 15px;
}

.company-info {
  padding-left: 15px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
  line-height: 1.2;
}

.company-tagline,
.company-regno,
.company-address,
.company-phone {
  margin-bottom: 3px;
  font-size: 11px;
  line-height: 1.3;
}

.invoice-details {
  page-break-inside: avoid;
  margin-bottom: 20px;
}

.table {
  width: 100%;
  page-break-inside: auto;
  border-collapse: collapse;
}

.table thead {
  page-break-after: avoid;
}

.table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

.table th,
.table td {
  padding: 6px 8px;
  line-height: 1.2;
  height: 30px;
}

.table td p {
  margin: 0;
  line-height: 1.2;
  min-height: 1.2em;
}

.table td p:empty::before {
  content: '\00a0';
}

.vehicle-details {
  page-break-inside: avoid;
  margin-top: 20px;
}

.vehicle-details p,
.signature p {
  margin: 0;
}

.signature {
  page-break-inside: avoid;
  margin-top: 30px;
}

@media print {
  .no-print {
    display: none !important;
  }

  .pdf-content {
    width: 794px;
    margin: 0;
    padding: 20px;
    box-shadow: none;
  }

  .pdf-content .card {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .pdf-content .card-body {
    padding: 0 !important;
  }

  .logo-image {
    max-width: 100px !important;
  }

  .company-name {
    font-size: 18px !important;
  }

  body {
    background: white;
  }

  .table {
    font-size: 11px;
  }

  .table th,
  .table td {
    padding: 5px 8px;
    line-height: 1.1;
    height: 28px;
  }

  .table td p {
    margin: 0;
    line-height: 1.1;
    min-height: 1.1em;
  }

  .table td p:empty::before {
    content: '\00a0';
  }
}

/* PDF Generation specific styles */
.pdf-content.pdf-generation {
  width: 794px !important;
  padding: 0 !important;
  margin: 0;
}

.pdf-content.pdf-generation .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.pdf-content.pdf-generation .card-body {
  padding: 0 !important;
}

.pdf-content.pdf-generation .no-print {
  display: none !important;
}

.pdf-content.pdf-generation .logo-image {
  max-width: 100px !important;
}

.pdf-content.pdf-generation .company-name {
  font-size: 18px !important;
}

.pdf-content.pdf-generation .table {
  width: 100%;
  font-size: 11px;
}

.pdf-content.pdf-generation .table th,
.pdf-content.pdf-generation .table td {
  padding: 5px 8px;
  line-height: 1.1;
  height: 28px;
}

.pdf-content.pdf-generation .table td p {
  margin: 0;
  line-height: 1.1;
  min-height: 1.1em;
}

.pdf-content.pdf-generation .table td p:empty::before {
  content: '\00a0';
}
</style>
